export const personalInfo = {
  name: "Anurag Pandey",
  firstName: "Anurag",
  lastName: "Pandey",
  title: "Software Development Engineer",
  tagline:
    "I build scalable backend systems and solve complex engineering problems.",
  bio: "SDE 2 with a passion for building high-performance distributed systems. Currently crafting scalable solutions at Stamina. Experienced in designing APIs, optimizing databases, and deploying robust microservices on AWS.",
  email: "contact@anuragpandey.dev",
  location: "India",
  social: {
    linkedin: "https://www.linkedin.com/in/josbeak/",
    leetcode: "https://leetcode.com/u/josbeak",
    codeforces: "https://codeforces.com/profile/josbeak",
    github: "https://github.com/josbeak",
  },
  /** Replace with your Calendly scheduling link (e.g. https://calendly.com/yourname/30min) */
  calendlyUrl: "https://calendly.com/anuragpandey4900/30min",
};

export const experience = [
  {
    id: 1,
    company: "Stamina",
    role: "Software Development Engineer 2",
    type: "Full-time",
    duration: "Jul 2025 — Present",
    description:
      "Building scalable backend infrastructure and APIs powering the next generation of fitness technology.",
    tech: ["Node.js", "PostgreSQL", "AWS", "Kafka"],
    current: true,
  },
  {
    id: 2,
    company: "Trustworthy",
    role: "Founding Engineer",
    type: "Full-time",
    duration: "Aug 2024 — Jul 2025",
    description:
      "Led architecture decisions and built core platform features from ground zero as the founding engineering member.",
    tech: ["Node.js", "PostgreSQL", "AWS", "Docker"],
    current: false,
  },
  {
    id: 3,
    company: "Nia XP",
    role: "Software Development Engineer 2",
    type: "Full-time",
    duration: "Jan 2025 — Apr 2025",
    description:
      "Designed and optimized high-throughput APIs and microservices handling millions of requests.",
    tech: ["Node.js", "AWS", "Kafka", "Docker"],
    current: false,
  },
  {
    id: 4,
    company: "BDI Plus",
    role: "Software Development Engineer Intern",
    type: "Internship",
    duration: "Apr 2024 — Aug 2024",
    description:
      "Developed backend services and contributed to the CI/CD pipeline, reducing deployment time significantly.",
    tech: ["Node.js", "PostgreSQL", "Docker"],
    current: false,
  },
  {
    id: 5,
    company: "Symbols App",
    role: "Open Source Contributor",
    type: "Contributor",
    duration: "Feb 2024 — Mar 2024",
    description:
      "Contributed features and bug fixes to the open-source Symbols App project.",
    tech: ["JavaScript", "Open Source"],
    current: false,
  },
  {
    id: 6,
    company: "Johnson Controls",
    role: "Software Development Engineer Intern",
    type: "Internship",
    duration: "Jan 2023 — Nov 2023",
    description:
      "Built internal tools and automation scripts for IoT device management and monitoring systems.",
    tech: ["Node.js", "AWS", "IoT"],
    current: false,
  },
];

export const projects = [
  {
    id: 1,
    name: "Riderpal",
    tagline: "For Riders Ecosystem",
    description:
      "A comprehensive platform built for the riders community — connecting riders, managing routes, and building a thriving ecosystem around motorcycle culture.",
    tech: ["Node.js", "PostgreSQL", "AWS", "Docker"],
    link: "#",
    featured: true,
  },
  {
    id: 2,
    name: "API Key Monitor",
    tagline: "Monitor API Key Usage",
    description:
      "A real-time monitoring system for tracking API key usage, rate limits, and anomaly detection across distributed services.",
    tech: ["Node.js", "Kafka", "PostgreSQL", "AWS SES"],
    link: "#",
    featured: true,
  },
];

export const techStack = [
  { name: "Node.js", category: "Backend" },
  { name: "PostgreSQL", category: "Database" },
  { name: "AWS", category: "Cloud" },
  { name: "Kafka", category: "Messaging" },
  { name: "Docker", category: "DevOps" },
  { name: "AWS SES", category: "Cloud" },
  { name: "Redis", category: "Database" },
  { name: "Git", category: "Tools" },
];

export const codingStats = {
  codeforces: {
    handle: "josbeak",
    currentRating: 1456,
    maxRating: 1562,
    rank: "Specialist",
    totalSolved: 214,
    contestsParticipated: 42,
    ratingHistory: [
      { contest: "Round #780", date: "2022-06-15", rating: 812 },
      { contest: "Round #790", date: "2022-08-20", rating: 965 },
      { contest: "Round #800", date: "2022-10-10", rating: 1087 },
      { contest: "Round #810", date: "2023-01-05", rating: 1042 },
      { contest: "Round #820", date: "2023-03-18", rating: 1198 },
      { contest: "Round #830", date: "2023-05-22", rating: 1156 },
      { contest: "Round #840", date: "2023-07-14", rating: 1345 },
      { contest: "Round #850", date: "2023-09-08", rating: 1298 },
      { contest: "Round #860", date: "2023-11-20", rating: 1412 },
      { contest: "Round #870", date: "2024-01-15", rating: 1378 },
      { contest: "Round #880", date: "2024-03-10", rating: 1498 },
      { contest: "Round #890", date: "2024-05-05", rating: 1445 },
      { contest: "Round #900", date: "2024-07-20", rating: 1562 },
      { contest: "Round #910", date: "2024-09-12", rating: 1489 },
      { contest: "Round #920", date: "2024-11-08", rating: 1523 },
      { contest: "Round #930", date: "2025-01-18", rating: 1498 },
      { contest: "Round #940", date: "2025-03-22", rating: 1534 },
      { contest: "Round #950", date: "2025-05-10", rating: 1456 },
    ],
  },
  leetcode: {
    handle: "josbeak",
    totalSolved: 347,
    easySolved: 124,
    mediumSolved: 178,
    hardSolved: 45,
    totalQuestions: { easy: 800, medium: 1700, hard: 750 },
    ranking: 48562,
    streak: 14,
  },
  totalQuestionsSolved: 561,
};

export const meetingSlots = [
  { id: 1, day: "Monday", time: "10:00 AM — 11:00 AM", available: true },
  { id: 2, day: "Monday", time: "2:00 PM — 3:00 PM", available: true },
  { id: 3, day: "Wednesday", time: "11:00 AM — 12:00 PM", available: true },
  { id: 4, day: "Wednesday", time: "4:00 PM — 5:00 PM", available: false },
  { id: 5, day: "Friday", time: "10:00 AM — 11:00 AM", available: true },
  { id: 6, day: "Friday", time: "3:00 PM — 4:00 PM", available: true },
];
